export default function phoneLink(numberUrl) {
  console.debug('phone link web');
  window.location = new URL(numberUrl, window.location).toString();
}
